<template>
  <div class="container head-container">
    <div class="header-section d-flex align-items-center justify-content-center">
      <div class="header-logo d-flex align-items-center">
        <h2>
          <img src="../assets/logo.svg" style="width:100%; height:100%"/>
        </h2>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center body-content" style="min-height: 75vh;">
      <div class="text-center" style="max-width: 500px; width: 100%;">
        <p class="font-18 mb-4 font-weight-bold">
          企業登録が完了しました！
        </p>
        <p class="font-16 mb-4 font-weight-bold">
          あなたに合った求人情報の閲覧が可能です
        </p>
        <button
          class="btn btn-cstm btn-cstm-primary mt-2 h-auto py-2"
          @click="handleOkClick"
          :style="buttonStyle"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyRegistrationComplete',
  props: {
    buttonStyle: {
      type: Object,
      default: () => ({
        background: '#006C6B',
        'border-color': '#006C6B'
      })
    }
  },
  methods: {
    handleOkClick() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.btn-cstm {
  padding: 15px 20px;
  width: 343px;
  border-radius: 3px;
  height: 55px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff !important;
  background-color: #006C6B !important;
  border-color: #006C6B !important;
}

.font-18 {
  font-size: 18px;
}

.font-16 {
  font-size: 16px;
}
</style> 